import 'url-search-params-polyfill';

export default function getUrlParameters(convert = false): {
    [key: string]: any
} {
    let urlParams = new URLSearchParams(window.location.search);
    let processedUrlParams: any = {};
    for (let entry of urlParams.entries()) {
        const key = entry[0];
        let value: string | boolean | number | null = entry[1];
        if (convert) {
            if (value.toLowerCase() === 'true')
                value = true;
            else if (value.toLowerCase() === 'false')
                value = false;
            else if (value.toLowerCase() === 'null')
                value = null;
            else if (!isNaN(parseFloat(value)))
                value = parseFloat(value);
        }
        processedUrlParams[key] = value;
    }
    return processedUrlParams;
}